import "./live-search-wrapper";
import "./live-search";

class SectionHeader extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);

    this.promoBar = document.querySelector("[data-js-promo-bar]");
    this.hero = document.querySelector("[data-hero]");
    this.header = this.closest(".header");
    this.body = document.querySelector("body");
    this.headerNav = this.querySelector("[data-js-header-nav]");
    this.openMiniCartTrigger = this.querySelector("[data-js-main-cart-btn]");
    // this.closeMiniCartTrigger = document.querySelectorAll(
    //   "[data-minicart-close]"
    // );

    this.lastScroll = 0;

    // this.miniCart = document.querySelector("[data-cart]");

    this.searchIcons = [...this.querySelectorAll("[data-js-search-icon]")];
    this.searchForm = this.querySelector(".header__search");
    this.searchFormClose = this.querySelectorAll("[data-search-form-close]");

    this.openNavTrigger = [
      ...this.querySelectorAll("[data-js-open-mobile-nav]"),
    ];
    this.closeNavTrigger = [
      ...this.querySelectorAll("[data-js-close-mobile-nav]"),
    ];
    this.navScrollContainer = [
      ...this.querySelectorAll("[data-js-nav-scroll-container]"),
    ];

    this.mainNavItems = [...this.querySelectorAll("[data-js-main-nav-item]")];

    this.panelOpeners = new Set();

    const closeEsc = (event) => {
      if (event.code.toUpperCase() !== "ESCAPE") return;

      if (
        this.mobileMenuOpen &&
        !this.querySelector(".header__nav__mega-menu-details[open]")
      ) {
        this.closeMobileNav();
      } else if (this.searchForm.classList.contains("active")) {
        this.closeSearchForm();
      }
    };

    document.addEventListener("keyup", closeEsc);

    this.initFunction();
  }

  disconnectedCallback() {
    document.removeEventListener("keyup", closeEsc);
  }

  initFunction() {
    this.handleScrollEvents();
    this.handleColor();
    window.addEventListener("scroll", this.handleScrollEvents.bind(this));
    this.openMiniCartTrigger.addEventListener("click", () =>
      document.dispatchEvent(new CustomEvent("mini-cart:open"))
    );
    // this.closeMiniCartTrigger.forEach((button) =>
    //   button.addEventListener("click", () =>
    //     document.dispatchEvent(new CustomEvent("mini-cart:close"))
    //   )
    // );

    this.openNavTrigger.forEach((button) =>
      button.addEventListener("click", this.openMobileNav.bind(this))
    );
    this.closeNavTrigger.forEach((button) =>
      button.addEventListener("click", this.closeMobileNav.bind(this))
    );

    this.searchIcons.forEach((icon) => {
      icon.addEventListener("click", (event) => {
        event.stopPropagation();
        if (this.searchForm.classList.contains("active")) {
          this.closeSearchForm();
        } else {
          this.openSearchForm();
        }
      });
    });

    this.searchFormClose.forEach((closeButton) => {
      closeButton.addEventListener("click", this.closeSearchForm.bind(this));
    });

    window.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.closeSearchForm();
      }
    });

    this.addEventListener("mega-menu:opened", (e) => {
      this.togglePanelOpen(true, e.target);
      this.classList.add("mega-menu-open");
    });

    this.addEventListener("mega-menu:closed", (e) => {
      this.togglePanelOpen(false, e.target);
      this.classList.remove("mega-menu-open");
    });

    window.addEventListener("resize", () => {
      if (window.matchMedia("(max-width: 1279px)").matches) return;

      this.closeMobileNav();
    });
  }

  handleScrollEvents() {
    window.clearTimeout(this.ticking);

    this.ticking = setTimeout(() => {
      window.headerIgnoreScroll = false;
    }, 50);

    if (window.headerIgnoreScroll) return;

    let fixedOffset = this.promoBar?.offsetHeight,
      screenOffset = window.innerHeight * 0.66,
      currentScroll = window.pageYOffset;

    // Throttle updates to improve performance
    if (Math.abs(currentScroll - this.lastScroll) < 30) return;

    this.body.classList[window.scrollY > fixedOffset ? "add" : "remove"](
      "is-scrolled"
    );
    const scrollDown =
      currentScroll - this.lastScroll > 0 && window.scrollY > screenOffset;
    this.body.classList.toggle("scroll-down", scrollDown);

    if (scrollDown) {
      document.dispatchEvent(new CustomEvent("mega-menu:close-all"));
    }

    this.body.classList[currentScroll - this.lastScroll > 0 ? "remove" : "add"](
      "scroll-up"
    );
    this.lastScroll = currentScroll;
  }

  handleColor() {
    if (!this.hero) {
      this.body.classList.remove("has-transparent-header");
    }
  }

  openMobileNav() {
    this.closeSearchForm();
    this.headerNav.style.display = "block";

    window.requestAnimationFrame(() => {
      this.header.classList.add("is-opened");
      this.returnFocusEl = document.activeElement;
      window.trapFocus(
        this.headerNav
      );

      document.documentElement.classList.add("overflow-hidden");
      this.navScrollContainer.forEach((container) => {
        container.classList.add("overflow-hidden");
      });
      this.mobileMenuOpen = true;
    })
  }

  closeMobileNav() {
    if (!this.mobileMenuOpen) return;

    window.removeTrapFocus(this.returnFocusEl);
    this.mobileMenuOpen = false;

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);
      this.headerNav.style.display = null;
    };

    this.addEventListener("transitionend", onEnd);

    document.dispatchEvent(new CustomEvent("mega-menu:close-all"));
    document.dispatchEvent(new CustomEvent("mobile-menu:close"));
    this.header.classList.remove("is-opened");
    this.headerNav.classList.remove("sub-opened");
    document.documentElement.classList.remove("overflow-hidden");
    this.navScrollContainer.forEach((container) => {
      container.classList.remove("overflow-hidden");
    });
  }

  openSearchForm() {
    if (this.searchForm.classList.contains("active")) return;
    this.closeMobileNav();

    // const inputWrapper = this.searchForm.querySelector(
    //   ".desktop-search__form"
    // );
    const barHeight = this.promoBar?.getBoundingClientRect().height || 0;
    const headerHeight = this.header.getBoundingClientRect().height;

    this.searchForm.style.setProperty(
      "--search-form-max-height",
      `calc(100vh - ${barHeight}px - ${headerHeight}px)`
    );

    this.searchForm.style.display = "block";
    document.body.classList.add("search-dimmer");
    this.togglePanelOpen(true, this.searchForm);

    window.requestAnimationFrame(() => {
      document.body.classList.add("search-dimmer--active");
      this.searchForm.classList.add("active");
      this.searchForm.querySelector(".desktop-search__query-input").focus();
      // this.searchForm.style.setProperty(
      //   "--search-close-top",
      //   `${inputWrapper.getBoundingClientRect().height / 2}px`
      // );
    });
  }

  closeSearchForm() {
    if (!this.searchForm.classList.contains("active")) return;

    const onTransitionEnd = () => {
      this.searchForm.style.display = "none";
      document.body.classList.remove("search-dimmer");
      this.searchForm.removeEventListener("transitionend", onTransitionEnd);
      this.searchIcons[0]?.focus();
      this.searchForm.querySelector('live-search-wrapper').dispatchEvent(new CustomEvent('live-search-wrapper:clear'));
    };

    this.searchForm.addEventListener("transitionend", onTransitionEnd);

    this.searchForm.classList.remove("active");
    document.body.classList.remove("search-dimmer--active");
    this.togglePanelOpen(false, this.searchForm);
  }

  togglePanelOpen(open, opener) {
    if (open) {
      this.panelOpeners.add(opener);
      this.header &&
        this.header.classList.add("panel-is-open", "show-overflow");
    } else {
      this.panelOpeners.delete(opener);
      if (!this.panelOpeners.size) {
        const handleTransitionEnd = (e) => {
          if (e.target !== this) return;

          this.removeEventListener("transitionend", handleTransitionEnd);
          this.header && this.header.classList.remove("show-overflow");
        };

        this.addEventListener("transitionend", handleTransitionEnd);
        this.header && this.header.classList.remove("panel-is-open");
      }
    }
  }
}

if (!customElements.get("section-header")) {
  customElements.define("section-header", SectionHeader);
}
